module.exports = __webpack_public_path__ + "assets/img/game-images-loader.34ddcdd7.svg";